export const name = '_gmt'
export const displayName = 'Green Metaverse Token'
export const ticker = `${name}_GMT`
export const displayTicker = 'GMT'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 8,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = ['gmt_bsc', '7i5k_solana_c9e04412']
